import { observer } from 'mobx-react';
import * as React from 'react';
import {
  AlreadyTranslated,
  TranslationsContext,
  translation,
} from '../../../../../../../Translations';
import Image from '../../../../../../Image';
import { ExperienceResource } from '../../../../../Types';
import LearningCollectionEditStore from '../../../../Edit/Store';
import { ModifiableExperiencesContext } from '../../../../Types';
import Competencies from '../Competencies';
import StartDates from './StartDates';
import { ShowUnlicensedToggle } from '../../ExperienceCatalog/Types';
import ProductTypeChip from './ProductTypeChip';

interface Props {
  context: ModifiableExperiencesContext;
  experienceResource: ExperienceResource;
  store: LearningCollectionEditStore;
  showLockIcon: ShowUnlicensedToggle;
}

const ExperienceRowItems: React.FC<Props> = ({
  context,
  experienceResource,
  store,
  showLockIcon,
}) => {
  const { id, title, schoolPartnerLogoUrl, description, competencies } = experienceResource.payload;
  return (
    <>
      <td className="min-w-[300px] py-6 pl-3 text-sm">
        <AlreadyTranslated content={title} />
      </td>
      <td className="min-w-[200px] pl-3">
        <Competencies id={id} competencies={competencies} />
      </td>
      <td className="min-w-[200px] pl-3 opacity-1">
        <ProductTypeChip showLockIcon={showLockIcon} experienceResource={experienceResource} />
      </td>
      <td className="min-w-[200px] pl-3">
        <StartDates context={context} experienceResource={experienceResource} store={store} />
      </td>
      <td className="min-w-[200px] py-6 pl-3">
        <div className="w-24">
          {schoolPartnerLogoUrl
            .map((url) => (
              <TranslationsContext.Consumer>
                {(ts) => (
                  <>
                    <Image src={url} alt={translation('University partner logo')(ts)} style={''} />{' '}
                  </>
                )}
              </TranslationsContext.Consumer>
            ))
            .getOrElse(() => (
              <></>
            ))}
        </div>
      </td>
      <td className="min-w-[150px] py-6 pl-3 text-sm font-normal">
        <AlreadyTranslated content={description} />
      </td>
    </>
  );
};

export default observer(ExperienceRowItems);
